"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteWebpageImpressionTrack = exports.WebViewExitMethod = void 0;
/* eslint-disable */
const common_snap_ad_impression_track_1 = require("./common_snap_ad_impression_track");
const webview_context_1 = require("./webview_context");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../../google/protobuf/wrappers");
/** Determines webview exit type */
var WebViewExitMethod;
(function (WebViewExitMethod) {
    /** WEBVIEW_EXIT_METHOD_UNSET - Unknown exit method */
    WebViewExitMethod[WebViewExitMethod["WEBVIEW_EXIT_METHOD_UNSET"] = 0] = "WEBVIEW_EXIT_METHOD_UNSET";
    /** EXIT_BUTTON - Tap on exit button */
    WebViewExitMethod[WebViewExitMethod["EXIT_BUTTON"] = 1] = "EXIT_BUTTON";
    /** APP_BACKGROUND - Exit the app or App backgrounded */
    WebViewExitMethod[WebViewExitMethod["APP_BACKGROUND"] = 2] = "APP_BACKGROUND";
    /** SWIPE_DOWN - Swiping down webview to close */
    WebViewExitMethod[WebViewExitMethod["SWIPE_DOWN"] = 3] = "SWIPE_DOWN";
    /** PAGE_BACK - Pressing back button/ going back */
    WebViewExitMethod[WebViewExitMethod["PAGE_BACK"] = 4] = "PAGE_BACK";
    WebViewExitMethod[WebViewExitMethod["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(WebViewExitMethod = exports.WebViewExitMethod || (exports.WebViewExitMethod = {}));
function createBaseRemoteWebpageImpressionTrack() {
    return {
        commonSnapAdImpression: undefined,
        loadedOnEntry: undefined,
        loadedOnExit: undefined,
        visibleLoadTime: undefined,
        pixelCookieSet: undefined,
        initalPageStatusCode: undefined,
        webpageHalfOpenViewedSeconds: undefined,
        webpageFatalError: undefined,
        apkDownloaded: undefined,
        webviewContext: undefined,
        webviewExitMethod: 0,
        packageIdHandlingAttachmentOpen: undefined,
    };
}
exports.RemoteWebpageImpressionTrack = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.commonSnapAdImpression !== undefined) {
            common_snap_ad_impression_track_1.CommonSnapAdImpressionTrack.encode(message.commonSnapAdImpression, writer.uint32(10).fork()).ldelim();
        }
        if (message.loadedOnEntry !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.loadedOnEntry }, writer.uint32(18).fork()).ldelim();
        }
        if (message.loadedOnExit !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.loadedOnExit }, writer.uint32(26).fork()).ldelim();
        }
        if (message.visibleLoadTime !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.visibleLoadTime }, writer.uint32(34).fork()).ldelim();
        }
        if (message.pixelCookieSet !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.pixelCookieSet }, writer.uint32(42).fork()).ldelim();
        }
        if (message.initalPageStatusCode !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.initalPageStatusCode }, writer.uint32(50).fork()).ldelim();
        }
        if (message.webpageHalfOpenViewedSeconds !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.webpageHalfOpenViewedSeconds }, writer.uint32(58).fork()).ldelim();
        }
        if (message.webpageFatalError !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.webpageFatalError }, writer.uint32(66).fork()).ldelim();
        }
        if (message.apkDownloaded !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.apkDownloaded }, writer.uint32(74).fork()).ldelim();
        }
        if (message.webviewContext !== undefined) {
            webview_context_1.WebViewContext.encode(message.webviewContext, writer.uint32(82).fork()).ldelim();
        }
        if (message.webviewExitMethod !== 0) {
            writer.uint32(88).int32(message.webviewExitMethod);
        }
        if (message.packageIdHandlingAttachmentOpen !== undefined) {
            wrappers_1.StringValue.encode({ value: message.packageIdHandlingAttachmentOpen }, writer.uint32(98).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRemoteWebpageImpressionTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.commonSnapAdImpression = common_snap_ad_impression_track_1.CommonSnapAdImpressionTrack.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.loadedOnEntry = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.loadedOnExit = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.visibleLoadTime = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.pixelCookieSet = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 6:
                    message.initalPageStatusCode = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 7:
                    message.webpageHalfOpenViewedSeconds = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 8:
                    message.webpageFatalError = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 9:
                    message.apkDownloaded = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 10:
                    message.webviewContext = webview_context_1.WebViewContext.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.webviewExitMethod = reader.int32();
                    break;
                case 12:
                    message.packageIdHandlingAttachmentOpen = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseRemoteWebpageImpressionTrack();
        message.commonSnapAdImpression =
            object.commonSnapAdImpression !== undefined &&
                object.commonSnapAdImpression !== null
                ? common_snap_ad_impression_track_1.CommonSnapAdImpressionTrack.fromPartial(object.commonSnapAdImpression)
                : undefined;
        message.loadedOnEntry = object.loadedOnEntry ?? undefined;
        message.loadedOnExit = object.loadedOnExit ?? undefined;
        message.visibleLoadTime = object.visibleLoadTime ?? undefined;
        message.pixelCookieSet = object.pixelCookieSet ?? undefined;
        message.initalPageStatusCode = object.initalPageStatusCode ?? undefined;
        message.webpageHalfOpenViewedSeconds =
            object.webpageHalfOpenViewedSeconds ?? undefined;
        message.webpageFatalError = object.webpageFatalError ?? undefined;
        message.apkDownloaded = object.apkDownloaded ?? undefined;
        message.webviewContext =
            object.webviewContext !== undefined && object.webviewContext !== null
                ? webview_context_1.WebViewContext.fromPartial(object.webviewContext)
                : undefined;
        message.webviewExitMethod = object.webviewExitMethod ?? 0;
        message.packageIdHandlingAttachmentOpen =
            object.packageIdHandlingAttachmentOpen ?? undefined;
        return message;
    },
};
//# sourceMappingURL=remote_webpage_impression_track.js.map